// Import scripts
import './vendor/slick.min';
import './vendor/masonry.pkgd';

// Styles
import '../sass/main.scss';

// Import asset images
import './images';

// Import javascript
// import debounce from './helpers/debounce';

import siteMenu from './partials/siteMenu';
import masonry from './partials/masonry';
import media from './partials/media';

import slickSettings from './partials/slickSettings';

jQuery(document).ready(function () {
    siteMenu(jQuery);
    masonry(jQuery);
    media(jQuery);

    slickSettings(jQuery);
});